<template>
  <div class="loginpage">
    <div class="logobox">
      <img src="@/assets/images/logo/logo.png" alt="" />
    </div>
    <div class="loginbox" style="position: relative;">
      <div class="tit">锐鹿投保系统</div>
      <el-form
        :model="login"
        :rules="rules"
        ref="login"
        label-width="100"
        @keypress.native.enter="landing()"
        class="login_Form"
        hide-required-asterisk
        ><el-form-item label="账号" prop="username">
          <el-input
            prefix-icon="el-icon-user"
            v-model="login.username"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="login.password"
            autocomplete="off"
            show-password
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="landing()"
            >提交</el-button
          >
        </el-form-item>
        <!-- <p
          @click="addAccountBtn"
          style="margin: 0;text-align: center;color: #595959;font-size: 14px;cursor: pointer;position: absolute;bottom: 31px;right: 51px;padding: 5px;"
        >
          注册
        </p> -->
        <a
          href="https://www.baigebao.com/NewHome/Article/information_disclosure.html" target="_blank"
          style="margin: 0;text-align: center;color: #595959;font-size: 14px;cursor: pointer;position: absolute;bottom: 31px;right: 51px;padding: 5px;"
        >
        查看信息披露
        </a>
        <a
          href="/平台服务协议.pdf" target="_blank"
          style="margin: 0;text-align: center;color: #595959;font-size: 14px;cursor: pointer;position: absolute;bottom: 31px;right: 155px;padding: 5px;"
        >
        平台服务协议
        </a>
        <a
          href="/白鸽宝隐私政策.pdf" target="_blank"
          style="margin: 0;text-align: center;color: #595959;font-size: 14px;cursor: pointer;position: absolute;bottom: 31px;right: 251px;padding: 5px;"
        >
        白鸽宝隐私政策
        </a>
        
      </el-form>
    </div>

    <!-- 注册新账号 -->
    <el-dialog
      title="注册新账号"
      :visible="accountVisible"
      @close="closeAccountBtn"
      width="540px"
    >
      <el-form
        :model="accountForm"
        :rules="rules2"
        :validate-on-rule-change="false"
        ref="accountForm"
        label-width="120px"
        class="accountForm"
        size="small"
      >
        <el-form-item label="账号" prop="username">
          <el-input v-model="accountForm.username" placeholder="请输入内容">
          </el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="nickname">
          <el-input v-model="accountForm.nickname" placeholder="请输入内容">
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="accountForm.password"
            placeholder="请输入内容"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repeatPassword">
          <el-input
            v-model="accountForm.repeatPassword"
            placeholder="密码必须是数字和字母的组合,最少六位"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="accountForm.phone" placeholder="请输入内容">
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="accountForm.email" placeholder="请输入内容">
          </el-input>
        </el-form-item>
        <div class="btnBox" style="text-align: center;">
          <el-button type="primary" @click="accountOk" size="small">
            确 定
          </el-button>
          <el-button @click="closeAccountBtn" size="small">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { login } from "@/api/login";
import { changeAdmin } from "@/api/user";
export default {
  name: "Login",
  data() {
    var password = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.accountForm.repeatPassword !== "") {
          this.$refs.accountForm.validateField("repeatPassword");
        }
        callback();
      }
    };
    var repPassWord = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.accountForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      login: {
        username: "",
        password: ""
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      loading: false,
      accountVisible: false,
      accountForm: {
        id: "",
        username: "",
        nickname: "",
        password: "",
        repeatPassword: "",
        group: [27],
        phone: "",
        email: "",
        pid: "1000700",
        team: "25",
        is_can_commission: 0,
        is_open_product: 1,
        status: "1"
      },
      rules2: {
        username: [
          { required: true, message: "账号不可为空", trigger: "blur" },
          {
            pattern: /^([a-zA-z]+|[0-9]+|[0-9a-zA-z])*$/,
            message: "账号只可以输入大小写字母、数字",
            trigger: "blur"
          }
        ],
        nickname: [
          { required: true, message: "真实姓名不可为空", trigger: "blur" },
          {
            pattern: /[\u4e00-\u9fa5]+/g,
            message: "真实姓名请输入中文",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "密码不可为空", trigger: "blur" },
          {
            min: 6,
            message: "密码长度不少于6个字符",
            trigger: "blur"
          },
          {
            pattern: /^(?![^a-zA-Z]+$)(?!\D+$)/,
            message: "密码必须是数字和字母的组合",
            trigger: "blur"
          },
          { validator: password, trigger: "blur" }
        ],
        repeatPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: repPassWord, trigger: "blur" }
        ],
        group: [{ required: true, message: "请选择所属岗位", trigger: "blur" }],
        phone: [
          { required: true, message: "手机号不可为空", trigger: "blur" },
          {
            pattern: /^1[0-9]{10}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "邮箱不可为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        pid: [{ required: true, message: "请选择上级", trigger: "blur" }],
        team: [{ required: true, message: "请选择团队", trigger: "blur" }],
        is_can_commission: [
          { required: true, message: "请选择能否分配佣金", trigger: "blur" }
        ],
        is_open_product: [
          { required: true, message: "请选择是否开放产品", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    landing() {
      let that = this;
      that.$refs.login.validate(valid => {
        if (valid) {
          that.loading = true;
          login(that.login)
            .then(function(res) {
              that.loading = false;
              console.log(res);
              if (res.code == 1) {
                that.$store.commit("addToken", res.data.token);
                that.$store.commit("addUser", res.data);
                that.$router.push({ path: "/" });
                that.$store.state.isLog = true;
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              that.loading = false;
              that.$message.error(error.msg);
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    // 注册
    addAccountBtn() {
      this.accountVisible = true;
      this.accountForm = {
        id: "",
        username: "",
        nickname: "",
        password: "",
        repeatPassword: "",
        group: [27],
        phone: "",
        email: "",
        pid: "1000700",
        team: "25",
        is_can_commission: 0,
        is_open_product: 1,
        status: "1"
      };
    },
    // 取消注册
    closeAccountBtn() {
      this.$nextTick(() => {
        this.$refs.accountForm.resetFields();
      });
      this.accountVisible = false;
    },
    //弹窗确定
    accountOk(e) {
      this.$refs.accountForm.validate(valid => {
        let that = this;
        console.log(valid);
        if (valid) {
          let loadind = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          let _data = {
            id: that.accountForm.id,
            username: that.accountForm.username,
            nickname: that.accountForm.nickname,
            password: that.accountForm.password,
            repeatPassword: that.accountForm.repeatPassword,
            group: that.accountForm.group.join(","),
            phone: that.accountForm.phone,
            email: that.accountForm.email,
            pid: that.accountForm.pid,
            team: that.accountForm.team,
            status: that.accountForm.status,
            is_can_commission: that.accountForm.is_can_commission,
            is_open_product: that.accountForm.is_open_product
          };
          console.log(that.accountForm);
          changeAdmin(_data)
            .then(function(res) {
              console.log(res);
              loadind.close();
              if (res.code == 1) {
                that.$message.success("注册成功，请登录");
                that.accountVisible = false;
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.loginpage {
  background-image: url("~@/assets/images/layout/loginbg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  // background: #2d3a4b;
  .logobox {
    position: absolute;
    top: 30px;
    left: 55px;
    height: 34px;
    img {
      max-height: 100%;
    }
  }
  .loginbox {
    padding: 45px 35px 80px;
    background-image: url("~@/assets/images/layout/logincentrebg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 440px;
    & > .tit {
      font-size: 24px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.75);
      line-height: 33px;
    }
    & > .login_Form {
      padding-top: 45px;
      .el-form-item {
        margin-bottom: 25px;
        label {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 20px;
          margin-bottom: 8px;
        }
      }
      .el-button {
        margin-top: 20px;
        width: 100%;
      }
    }
  }
}
</style>
